import dayjs from 'dayjs'

import type { RecentCategory } from '../../components/search/commandPalette/types'

export const renderEntityId = (entityId: unknown): string => {
  if (typeof entityId === 'string') {
    return entityId
  }
  if (typeof entityId !== 'object' || !entityId) {
    throw new Error(`Cannot render ${entityId}`)
  }
  return Object.values(entityId).join(', ')
}

export const recentCategoryByDate = (date: string): RecentCategory => {
  const parsedDate = dayjs(date)
  if (dayjs().isSame(parsedDate, 'day')) {
    return 'RecentVisitToday'
  }
  if (dayjs().subtract(1, 'day').isSame(parsedDate, 'day')) {
    return 'RecentVisitYesterday'
  }
  if (dayjs().subtract(8, 'day').isBefore(parsedDate, 'day')) {
    return 'RecentVisitLastWeek'
  }
  // Since we only return 7 days of history from useCookie this should never get hit, but it's good to have a fallback just in case.
  return 'RecentVisitOlder'
}
